import React, { RefObject } from "react";
import { aplDebounce } from "../../aplUtils/aplDebounce";
import { useNavigate } from "react-router-dom";
import { translateString } from "../../translations/gridTranslationHelper";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { useSelector } from "react-redux";
import { IRootState } from "../../types/redux/IRootStore";
import { ModalType } from "../common/Modals/types/modalType";
import BottomButtonTemplate from "../common/BottomButtonTemplate";
import { useAppDispatch } from "../../redux/hooks";
import { onManualBarcodeInputChange } from "../../redux/slices/consumptionDetails.feature";
import { Tooltip } from "react-tooltip";
import { renderToString } from "react-dom/server";

const ConsumptionDetailsBottomButttons = (props: {
    handleClick: (barcode: string) => void;
    barcode: string;
    setBarcode: (barcode: string) => void;

    return: boolean;
    consume: boolean;
    delete: boolean;
    block: boolean;

    returnFunc: () => void;
    consumeFunc: () => void;
    deleteFunc: () => void;
    blockFunc: () => void;
}) => {
    const textboxRef = React.useRef() as RefObject<HTMLInputElement>;
    const navigate = useNavigate();
    const aplSetttings = AplSettingsSelector();
    const modalShown = useSelector((state: IRootState) => state.modalPallets2.modalShown);
    const manualBarcodeInput = useSelector((state: IRootState) => state.consumptionDetails.manualBarcodeInput);
    const dispatch = useAppDispatch();

    const updateBarcode = (barcode: string, skipTimeout: boolean) => {
        props.setBarcode(barcode);

        if (!manualBarcodeInput || skipTimeout) {
            aplDebounce(
                () => {
                    props.handleClick(barcode);
                },
                skipTimeout ? 0 : 600,
                false
            );
        }
    };

    React.useEffect(() => {
        setTimeout(() => {
            if (textboxRef && textboxRef.current && modalShown === ModalType.None) {
                textboxRef.current.focus();
            }
        }, 200);
    }, [modalShown]);

    return (
        <div className="mt-2">
            <div id="div-bottom-buttons" className="row float-left btn-group ml-0" role="group" aria-label="Bottom action buttons">
                <BottomButtonTemplate
                    text={translateString("return", aplSetttings.culture)}
                    enabled={props.return}
                    func={props.returnFunc}
                />
                <BottomButtonTemplate
                    text={translateString("consume", aplSetttings.culture)}
                    enabled={props.consume}
                    func={props.consumeFunc}
                />
                <BottomButtonTemplate
                    text={translateString("delete", aplSetttings.culture)}
                    enabled={props.delete}
                    func={props.deleteFunc}
                />
                <BottomButtonTemplate
                    text={translateString("addDefect", aplSetttings.culture)}
                    enabled={props.block}
                    func={props.blockFunc}
                />
            </div>
            <div id="div-bottom-buttons" className="row float-right btn-group mr-0" role="group" aria-label="Bottom action buttons">
                <div className="input-group mb-3">
                    <input
                        type="text"
                        id="txt-scan-new-material"
                        className="form-control"
                        placeholder={translateString("barcode", aplSetttings.culture)}
                        aria-label="Date Start"
                        aria-describedby="scan-new-material"
                        onChange={e => {
                            updateBarcode(e.target.value, false);
                        }}
                        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                            if (e.key === "Enter") {
                                updateBarcode(props.barcode, true);
                            }
                        }}
                        value={props.barcode}
                        autoFocus={true}
                        ref={textboxRef}
                        autoComplete="off"
                    />

                    <div className="input-group-append">
                        <button
                            id="btn-scan-new-material"
                            className="btn btn-primary"
                            type="button"
                            onClick={() => {
                                updateBarcode(props.barcode, true);
                            }}
                        >
                            <span
                                className="spinner-border spinner-border-sm submit-button-spinner d-none"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            {translateString("scanNewMaterial", aplSetttings.culture)}
                        </button>
                        &nbsp;
                        <Tooltip
                            id="manual-entry-tooltip"
                            html={renderToString(<span>{translateString("manualEntry", aplSetttings.culture)}</span>)}
                        />
                        <button
                            className={`btn ${!manualBarcodeInput ? "btn-primary" : "btn-danger"} `}
                            type="button"
                            onClick={e => dispatch(onManualBarcodeInputChange(!manualBarcodeInput))}
                            data-tooltip-delay-hide={333}
                            data-tooltip-id="manual-entry-tooltip"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-pencil-square"
                                viewBox="0 0 16 16"
                            >
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                <path
                                    fillRule="evenodd"
                                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                />
                            </svg>
                        </button>
                        &nbsp;
                        <button className="btn btn-primary" type="button" onClick={() => navigate("/consumption")}>
                            {translateString("back", aplSetttings.culture)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConsumptionDetailsBottomButttons;
